import React, { useCallback, useRef, useState } from 'react';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from 'react-hook-form';
import { validateNoStartOrEndSpace } from '../../cutomValidationField';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { complaintFeedback } from '../../api/apiHandler';
import { showPromiseNotification } from '../../common/notification';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../i18';
import Select from 'react-select';
import { reactSelectStyles } from '../../common/customCss';
import { useSelector } from 'react-redux';
import { uploadFileToS3 } from '../../common/uploadToS3';

const ComplaintFeedbackForm = () => {
    const { t } = useTranslation();

    const issueRef = useRef(null);
    const [issueImg, setIssueImg] = useState('');
    const [issueImgError, setIssueImgError] = useState('');
    const [queError, setQueError] = useState('');
    const [phone, setPhone] = useState('91');
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [issueImgPreview, setIssueImgPreview] = useState(null);
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.auth.userInfo)

    const complaintFeedbackSchema = Yup.object().shape({
        full_name: Yup.string()
            .test('no-start-or-end-space', t('noStartEndSpace', { field: t("Name") }), validateNoStartOrEndSpace).notRequired()
            .min(2, t("min", { field: t("Name"), value: 2 }))
            .max(50, t("max", { field: t("Name"), value: 50 }))
            .matches(/^[a-zA-Z\s'-]*$/, t("fullNameValidation", { field: t("Name") })),

        phone_number: Yup.string()
            .trim()
            .matches(
                /^(\+\d{1,3}[- ]?)?\d{10}$/,
                t('valid', { field: t("phone_number") })
            )
            .required(t("required", { field: t("phone_number") })),
        // description: Yup.string()
        //     .required(t("required", { field: t("issue") }))

        // description: Yup.string()
        //     .required(t("required", { field: t("message") }))
        //     .min(10, t("min", { field: t("Message"), value: 10 }))
        //     .max(1000, t("max", { field: t("Message"), value: 1000 }))
        //     .test('no-start-or-end-space', t('noStartEndSpace', { field: t("Message") }), validateNoStartOrEndSpace),
    });

    const formOptions = { resolver: yupResolver(complaintFeedbackSchema) };
    const { register, handleSubmit, formState, reset } = useForm(formOptions);
    const { errors } = formState;

    const uploadIssueEvent = (e) => {
        const file = e.target.files[0];

        if (file) {
            // Check if the file is an image
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!allowedTypes.includes(file.type)) {
                setIssueImgError(t("invalidImageType"));
                setIssueImg('');
                setIssueImgPreview(null); // Clear the preview
                return;
            }

            // Check if the file size exceeds 2MB
            if (file.size > 2 * 1024 * 1024) {
                setIssueImgError(t("fileSizeLimitExceeded"));
                setIssueImg('');
                setIssueImgPreview(null); // Clear the preview
                return;
            }

            // Generate a new file name with timestamp to avoid naming conflicts
            const timestamp = new Date().getTime();
            const newFileName = `${timestamp}_${file.name.replace(/\s+/g, '_')}`;
            const newFile = new File([file], newFileName, { type: file.type });

            setIssueImg(newFile);
            setIssueImgError(''); // Clear error if file is valid
            setIssueImgPreview(URL.createObjectURL(file)); // Set image preview URL
        }
    };


    const onSubmit = useCallback(
        async (values) => {
            if (!issueImg && issueImg === '') {
                setIssueImgError(t("uploadIssueSS"));
                return;
            }
            if (!selectedQuestion) {
                setQueError(t("selectFieldName", { field: t("Issue") }));
                return;
            }
            const issueImage = await uploadFileToS3(issueImg, "complaint_feedback", "public-read-write");

            values.country_code = phone
            values.image = issueImage.fileName
            values.description = selectedQuestion
            values.full_name = userInfo?.full_name
            const myPromise = new Promise(async (resolve, reject) => {
                await complaintFeedback(values)
                    .then((response) => {
                        if (response.code === 200) {
                            resolve(response);
                            navigate("/profile");
                        }
                        else {
                            reject(response);
                        }
                    })
            })
            showPromiseNotification(myPromise);
            reset();
            setIssueImg('');
            setPhone('91')
        },
        [issueImg, reset, phone, selectedQuestion, userInfo, t, navigate]
    );

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('complaintFeedbackFormHeading')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="counter-area">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 mt-2 mt-sm-2 mt-lg-0">
                                    <form className="contact-form-inner" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="single-input-inner style-bg-border">
                                                    <input type="text" placeholder={t("enterFieldName", { field: t("Name") })} name='full_name'
                                                        defaultValue={userInfo?.full_name} disabled
                                                        {...register('full_name')}
                                                    />
                                                    <p className="text-danger mt-1">
                                                        {errors.full_name?.message}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="single-input-inner style-bg-border">
                                                    <div className="single-input-inner style-bg-border" style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                            <PhoneInput
                                                                country={'in'}
                                                                value={phone}
                                                                onChange={(phone, data) => {
                                                                    setPhone(data.dialCode)
                                                                }}
                                                                inputProps={{
                                                                    name: 'phone',
                                                                    required: true,
                                                                    autoFocus: true,
                                                                    disabled: true
                                                                }}
                                                                containerStyle={{ width: '150px', height: '50px' }}
                                                                inputStyle={{ width: '100%', height: '100%' }}
                                                            />
                                                            <input
                                                                type="number"
                                                                placeholder={t("enterFieldName", { field: t("Phone_Number") })}
                                                                name='phone_number'
                                                                defaultValue={userInfo?.phone_number}
                                                                {...register('phone_number')}
                                                                onChange={(e) => {
                                                                    const inputValue = e.target.value;
                                                                    if (inputValue.length > 10) {
                                                                        e.target.value = inputValue.slice(0, 10);
                                                                    }

                                                                    if (inputValue.length <= 10) {
                                                                        e.target.value = inputValue;
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        <p className="text-danger" style={{ display: 'block' }}>
                                                            {errors.phone_number?.message}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="single-input-inner style-bg-border">
                                                    <div className="ProfileOtherPageBox">
                                                        <div className="cloud">
                                                            {issueImgPreview ? (
                                                                <img
                                                                    src={issueImgPreview}
                                                                    alt="Issue Preview"
                                                                    style={{
                                                                        maxWidth: '200px',
                                                                        maxHeight: '200px',
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #ddd'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <>
                                                                    <img
                                                                        src={process.env.PUBLIC_URL + "/assets/img/icon/cloud1.svg"}
                                                                        alt="cloud"
                                                                        className="cloud-img"
                                                                    />
                                                                    <span className="upload-text">
                                                                        {issueImg ? issueImg.name : t("issueSS")}
                                                                    </span>
                                                                    <span className="upload-text">
                                                                        {issueImg ? issueImg.name : t("issueSize")}
                                                                    </span>
                                                                </>
                                                            )}
                                                            <input
                                                                type="file"
                                                                className="form-control apply-input-file"
                                                                placeholder={t('selectFieldName', { field: t("Subject") })}
                                                                id="field2"
                                                                name="issueImg"
                                                                accept="image/*"
                                                                ref={issueRef}
                                                                onChange={uploadIssueEvent}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    opacity: 0,
                                                                    cursor: 'pointer'
                                                                }}
                                                            />
                                                        </div>
                                                        <p className="text-danger">{issueImgError}</p>
                                                        {/* Image Preview */}
                                                        {/* {issueImgPreview && (
                                                            <div className="mt-3 text-center">
                                                                <img
                                                                    src={issueImgPreview}
                                                                    alt="Issue Preview"
                                                                    style={{
                                                                        maxWidth: '200px',
                                                                        maxHeight: '200px',
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #ddd'
                                                                    }}
                                                                />
                                                                <p className="mt-2">{t("imagePreview")}</p>
                                                            </div>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                {/* <div className="single-input-inner style-bg-border mb-0"> */}
                                                <Select name="security_question" id="security_question"
                                                    placeholder={t('selectFieldName', { field: t("Issue") })}
                                                    defaultValue={selectedQuestion}
                                                    onChange={(data) => {
                                                        setSelectedQuestion(data.value)
                                                        if (data.label) {
                                                            setQueError(''); // Clear error if a valid option is selected
                                                        }
                                                    }}
                                                    options={[
                                                        { value: 'Developer Issue', label: t("developerIssue") },
                                                        { value: 'UI/UX Issue', label: t("uiUxIssue") },
                                                        { value: 'Other', label: t("other") },
                                                    ]}
                                                    styles={reactSelectStyles}
                                                />
                                                {/* </div> */}
                                                <p className="text-danger">
                                                    {queError}
                                                </p>
                                            </div>
                                            <div className="col-12 mt-5">
                                                <div className="d-flex justify-content-center">
                                                    <button className="btn btn-base" type='submit'>{t('sendMessage')}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ComplaintFeedbackForm;